import React from 'react';

import AthleteListActionBanner from './AthleteListActionBanner';

interface ISendWaiverBannerProps {
  count: number;
  onReview: () => void;
}

const SendWaiverBanner = ({ count, onReview }: ISendWaiverBannerProps): JSX.Element => (
  <AthleteListActionBanner
    message={`${count} ${count === 1 ? 'athlete is' : 'athletes are'} eligible to be sent a waiver.`}
    actionLabel='Review and send'
    onAction={onReview}
    bannerDataCy='sendWaiverBanner'
    buttonDataCy='reviewSendWaiverBtn'
  />
);

export default SendWaiverBanner;
